module.exports = "/_next/static/images/elf_white-21c56923cffe86f72e7b18a9d5dffa90.png";